class AgePopup extends HTMLElement {
    constructor() {
        super();

        this.popup = this;
        this.timeToShow = parseInt(this.popup.getAttribute('data-delay'));
        this.expiresDate = this.popup.getAttribute('data-expire');

        // MBB customization, delay age popup until interaction
        if (!window.sessionStorage.getItem('age-popup')) {
          var loadedAt = Date.now();
          EsOpt.afterInit(() => {
            setTimeout(function() {
                document.body.classList.add('newsletter-show');
            },Math.max(0, this.timeToShow - (Date.now() - loadedAt)))
          })
          // window.onload = function() {
            
          //   document.addEventListener('mousemove', () => {
          //     if (timer) { return; }
          //     timer = setTimeout(function() {
          //       document.body.classList.add('newsletter-show');
          //     },Math.max(0, this.timeToShow - (Date.now() - loadedAt)));
          //   });
          //   document.addEventListener('touchmove', () => {
          //     if (timer) { return; }
          //     timer = setTimeout(function() {
          //       document.body.classList.add('newsletter-show');
          //     },Math.max(0, this.timeToShow - (Date.now() - loadedAt)));
          //   });
          // }
        }
      this.querySelector('[data-close-newsletter-popup]').addEventListener(
            'click',
            this.setClosePopup.bind(this)
        );
    }

    setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        const expires = 'expires=' + d.toUTCString();
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    }

    setClosePopup() {
       window.sessionStorage.setItem('age-popup', 1);
        document.body.classList.remove('newsletter-show');
    }
}

customElements.define('age-popup', AgePopup);